import crossroads from 'crossroads';
import './Controllers';

crossroads.parse(`${window.location.pathname}${window.location.search}`);
